import classNames from "classnames";
import style from "./AppSearchFilters.module.scss";
import { useSelector } from "react-redux";
import { selectTopicResults } from "../../../features/enhancedSearch";
import { useEffect, useState } from "react";
import AppGuidelineItem from "./AppGuidelineItem";
import PropTypes from "prop-types";

const AppSearchFilters = ({ setShowFilters, search, navigate }) => {
  const searchResults = useSelector(selectTopicResults);
  const [selectedGuidelines, setSelectedGuidelines] = useState([]);
  const [guidelinesLoaded, setGuidelinesLoaded] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(true);
  const [searchWithin, setSearchWithin] = useState("");
  const [isFilterExpanded, setIsFilterExpanded] = useState(true);

  const hanldeClearAll = () => {
    setSelectedGuidelines([]);
    setSearchWithin("");
  };

  const updateResults = () => {
    const selectedGuideline = selectedGuidelines;
    const searchParams = new URLSearchParams(search);

    if (searchParams.has("appendedinputbuttons")) {
      const urlSearch = searchParams.get("appendedinputbuttons");
      const urlParts = [`appendedinputbuttons=${encodeURIComponent(urlSearch)}`];

      // Add guideline filters if any are selected
      if (selectedGuideline.length > 0) {
        const guidelineFilterParams = selectedGuideline
          .map((guideline) => `guidelinefilter=${encodeURIComponent(guideline)}`)
          .join("&");
        urlParts.push(guidelineFilterParams);
      }

      // Add searchWithin if it has a value
      if (searchWithin.trim()) {
        urlParts.push(`searchwithin=${encodeURIComponent(searchWithin.trim())}`);
      }

      navigate(`/searchAction/?${urlParts.join("&")}`);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const guidelineFilters = searchParams.getAll("guidelinefilter");
    if (guidelineFilters.length > 0) {
      // Parse multiple guideline filters from separate parameters
      setSelectedGuidelines(guidelineFilters);
    }

    // Parse searchWithin parameter from URL
    const searchWithinParam = searchParams.get("searchwithin");
    if (searchWithinParam) {
      setSearchWithin(decodeURIComponent(searchWithinParam.replace(/\+/g, " ")));
    }

    setGuidelinesLoaded(true);
  }, [search]);

  return (
    <div className={classNames("size-14", style.filterContainer)}>
      <div>
        <div className={style.header}>
          <button
            className={style.closeButton}
            type="button"
            onClick={() => setShowFilters(false)}
            data-testid="crossButton"
          >
            <i className="tg-icons-Cross size-22"></i>
          </button>
          <div className={classNames("size-22", style.filterText)}>Filters</div>
          <button
            className={classNames("size-16", style.clearButton)}
            onClick={hanldeClearAll}
            type="button"
          >
            Clear all
          </button>
        </div>

        <div className={classNames(style.section, style.searchWithin)}>
          <div className={style.searchWithinTitle}>
            <span className={style.subheading}>Search within results</span>
            <button
              className={style.toggleButton}
              onClick={() => setIsSearchExpanded(!isSearchExpanded)}
              data-testid="search-within-result"
            >
              {isSearchExpanded ? (
                <i className="fa banner-head-topic fa-angle-down"></i>
              ) : (
                <i className="fa banner-head-topic fa-angle-up"></i>
              )}
            </button>
          </div>

          {isSearchExpanded && (
            <div className={style.searchContent}>
              <label className={style.searchLabel}>
                Type keywords to refine your current results:
              </label>
              <input
                type="text"
                className={style.searchInput}
                value={searchWithin}
                onChange={(e) => {
                  setSearchWithin(e.target.value);
                }}
                placeholder="e.g treatment, symptoms"
              />
            </div>
          )}
        </div>

        <div className={classNames("bold", style.guidelineHeader)}>
          <span>Filter by guideline</span>
          <button
            className={style.toggleButton}
            onClick={() => {
              setIsFilterExpanded(!isFilterExpanded);
            }}
            data-testid="search-filters"
          >
            {isFilterExpanded ? (
              <i className="fa banner-head-topic fa-angle-down"></i>
            ) : (
              <i className="fa banner-head-topic fa-angle-up"></i>
            )}
          </button>
        </div>
      </div>
      {isFilterExpanded && (
        <div className={style.filters}>
          <ul className={style.guidelineList}>
            {guidelinesLoaded &&
              searchResults?.avaiableGuidelineFacets &&
              Object.keys(searchResults?.avaiableGuidelineFacets)
                .sort(
                  (a, b) =>
                    searchResults.avaiableGuidelineFacets[b] -
                    searchResults.avaiableGuidelineFacets[a],
                )
                ?.map((title) => (
                  <AppGuidelineItem
                    guideline={title}
                    resultCount={searchResults?.avaiableGuidelineFacets[title]}
                    selectedGuideline={selectedGuidelines}
                    key={title}
                    updateSelected={setSelectedGuidelines}
                  />
                ))}
          </ul>
        </div>
      )}

      <div className={style.buttonSection}>
        <div className={style.buttonDiv}>
          <button onClick={updateResults} className={style.showResultsButton}>
            Apply filters
          </button>
        </div>
        {/* <div className={style.buttonDiv}>
          <button
            className={style.cancelButton}
            onClick={() => setShowFilters(false)}
          >
            Cancel
          </button>
        </div> */}
      </div>
    </div>
  );
};

AppSearchFilters.propTypes = {
  setShowFilters: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default AppSearchFilters;
